module.exports = __webpack_public_path__ + "static/media/about1.2e45b584.webp";